import { reduxKey } from '../../constants';
import { reduxModuleLoaded, init } from '../actions';
import reducers from '../reducers/index';
import saga from '../sagas/index';
export function getModule({ gruser, gruserPage }) {
    return {
        id: 'gruserModule',
        reducerMap: {
            [reduxKey]: reducers
        },
        sagas: [
            saga
        ],
        retained: false,
        initialActions: [
            reduxModuleLoaded(),
            init({
                gruser,
                gruserPage
            })
        ]
    };
}
